import { AuthService } from './../../shared/models/auth.service';
import { CompanyAdminModel } from './../../company-admin/models/companyAdmin.model';
import { Injectable, Query, QueryList } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { CompanyModel } from './company.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class CompanyService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetCompanyList(input?: DataListModel): Observable<IAPIResponse> {
    let getCompanyUrl = WeGoConfig.API_GET_COMPANY_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getCompanyUrl = getCompanyUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportCompanyList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getUrl = WeGoConfig.API_EXPORT_COMPANY_LIST + "?" + queryString;
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options);
  }

  public GetCompanyByHashId(companyHashId: string): Observable<IAPIResponse> {
    let getCompnayUrl =
      WeGoConfig.API_GET_COMPNAY_BY_HASH + "?companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompnayUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCompanyBasicDetail(
    companyHashId: string
  ): Observable<IAPIResponse> {
    let getCompnayUrl =
      WeGoConfig.API_GET_COMPANY_BASIC_DETAIL +
      "?companyHashId=" +
      companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompnayUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddCompany(companyModel: CompanyModel): Observable<IAPIResponse> {
    let body = companyModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_COMPANY_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteCompany(
    selectedCompanyList: string[]
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_DELETE_COMPANY, selectedCompanyList, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public UpdateCompanyContactPerson(
    companyHashId: string,
    personHashId: string
  ): Observable<IAPIResponse> {
    let getComapanyUrl =
      WeGoConfig.API_UPDATE_COMPANY_CONTACT_PERSON +
      "?companyHashId=" +
      companyHashId +
      "&personHashId=" +
      personHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getComapanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPersonListByCompanyId(
    companyMasterHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getPersonUrl = WeGoConfig.API_GET_PERSON_LIST_BY_COMPANY_ID;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getPersonUrl =
        getPersonUrl +
        "?" +
        queryString +
        "&companyMasterHashId=" +
        companyMasterHashId;
    } else {
      getPersonUrl =
        getPersonUrl + "?companyMasterHashId=" + companyMasterHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPersonListForContactPerson(
    companyMasterHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getPersonUrl = WeGoConfig.API_GET_COMPANY_CONATACT_PERSON_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getPersonUrl =
        getPersonUrl +
        "?" +
        queryString +
        "&companyMasterHashId=" +
        companyMasterHashId;
    } else {
      getPersonUrl =
        getPersonUrl + "?companyMasterHashId=" + companyMasterHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public RemocveCompanyContactPerson(
    companyHashId: string
  ): Observable<IAPIResponse> {
    let getComapanyUrl =
      WeGoConfig.API_REMOVE_COMPANY_CONTACT_PERSON +
      "?companyHashId=" +
      companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getComapanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public InActiveCompanyAdmin(companyAdminHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_INACTIVE_COMPANY_ADMIN +
      "?companyAdminHashId=" +
      companyAdminHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public IsGeofenceEnables(companyHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_GEOFENCE + "?companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public IsOdometerConfigEnabled(companyHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_ODOMETER_CONFIG + "?companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }


  public IsTwoFaEnabled(companyHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_TWOFA_ENABLED_COMPANY + "?companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }


  public GetInstanceLanguage(companyHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_INSTANCE_LANGUAGE_BY_COMPANY +
      "?companyHashId=" +
      companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetLocationMode(companyHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_LOCATION_MODE + "?companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCompanybyInstance(
    instanceHashId: string
  ): Observable<IAPIResponse> {
    let getCompanyUrl =
      WeGoConfig.API_GET_COMPANY_BY_INSTANCE +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetCompanyByInstance(
    instanceHashId: string
  ): Observable<IAPIResponse> {
    let getCompanyUrl =
      WeGoConfig.API_GET_COMPANY_BY_INSTANCE +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCompanybyInstanceHashId(
    input: DataListModel,
    instanceHashId: string
  ): Observable<IAPIResponse> {
    let queryString = this.authService.HandleAPIListInput(input);
    let getCompanyUrl =
      WeGoConfig.API_GET_COMPANY_BY_INSTANCEHASHID +
      "?" +
      queryString +
      "&instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownCompanyList(
    reportName: string,
    instanceHashId: string
  ): Observable<IAPIResponse> {
    let getCompanyUrl: string;
    // getCompanyUrl = WeGoConfig.API_GET_COMPANY_LIST;

    switch (reportName) {
      case "Vehicle_Occupancy_Report":
        getCompanyUrl =
          WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_VEHICLEOCCUPANCYREPORT;
        break;
      case "Revenue_Per_Vehicle_Report":
        getCompanyUrl =
          WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_REVENUEVEHICLEREPORT;
        break;
      case "Maintenance_Planning_Report":
        getCompanyUrl =
          WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_MAINTENCEPLANNINGREPORT;
        break;
      case "TripData_Report":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_TRIPDATAREPORT;
        break;
      case "Admin_Dashboard":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_DASHBOARD;
        break;
      case "Kick_Back_Report":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMAPNY_LIST_KICKBACKREPORT;
        break;
      case "Cost_Center_Report":
        getCompanyUrl =
          WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_FOR_COST_CENTER_REPORT;
        break;
      default:
        getCompanyUrl =
          WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_VEHICLEOCCUPANCYREPORT;
        break;
    }

    getCompanyUrl = getCompanyUrl + "?instanceHashId=" + instanceHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  // public GetCompanyListDropdownForAddUpdatePage1(pageName: string, permissionType: string, instanceHashId?: string): Observable<IAPIResponse> {
  //     let getCompanyUrl: string;
  //     switch (pageName) {
  //         case "SharedVehicleGroup":
  //             getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_SVG;
  //             break;
  //         case "Organization":
  //             getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_ORGANIZATION;
  //             break;
  //         case "Vehicle":
  //             getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_VEHICLE;
  //             break;
  //         // case "person":
  //         //   getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_PERSON;
  //         //   break;
  //         default:
  //             getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_VEHICLEOCCUPANCYREPORT;
  //             break;
  //     }

  public GetDropdownCompanyListByInstanceIdList(reportName: string, permissionType: string, instanceHashIds: string[]): Observable<IAPIResponse> {
    let getCompanyUrl: string;

    switch (reportName) {
      case "Terms_And_Condition":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_BY_INSTANCE_LIST_TERMS_AND_CONDITION;
        break;
    }

    if (permissionType) {
      getCompanyUrl = getCompanyUrl + '?permissionType=' + permissionType;
    }

    let queryString = '';
    instanceHashIds.forEach(element => {
      queryString += "&instanceHashIdList=" + element;
    })

    getCompanyUrl = getCompanyUrl + queryString;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getCompanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaCookies(companyHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_COOKIES_COMPANY + "?companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaKeys(companyHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_KEYS_COMPANY + "?companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCompanyListDropdownForAddUpdatePage(
    pageName: string,
    permissionType: string,
    instanceHashId?: string,
    customerHashId?: string
  ): Observable<IAPIResponse> {
    let getCompanyUrl: string;
    switch (pageName) {
      case "SharedVehicleGroup":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_SVG;
        break;
      case "Organization":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_ORGANIZATION;
        break;
      case "Branding":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_BRANDING;
        break;
      case "Vehicle":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_VEHICLE;
        break;
      case "Template":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_TEMPLATE;
        break;
      case "Terms_And_Condition":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_TERMS_AND_CONDITION;
        break;
      case "invoice_update":
        getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_INVOICE_UPDATE;
        break;
      case "Pre Post Trip Question":
        getCompanyUrl =
          WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_PRE_POST_TRIP_QUESTION;
        break;
      default:
        getCompanyUrl = WeGoConfig.API_GET_COMPANY_LIST;
        break;
    }

    if (permissionType) {
      getCompanyUrl = getCompanyUrl + '?permissionType=' + permissionType;
    }
    if (instanceHashId) {
      getCompanyUrl = getCompanyUrl + "&instanceHashId=" + instanceHashId;
    }
    if (customerHashId) {
      getCompanyUrl = getCompanyUrl + "&customerHashId=" + customerHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getCompanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/company/models/company.service.ts